import axios from "axios";
import { getToken } from "./auth";

//  export const baseURL = "http://localhost:8000/api";
  // export const baseURL = "http://localhost/bettercare_laravel/api";
// export const baseURL = "https://lala.bettercare.co.mz/api";
export const baseURL = "https://interface.genitomedical.co.mz/api";
//  export const baseURL = "https://api.bettercare.co.mz/api";
//  export const baseURL = "https://server.bettercare.tech/api";

const api = axios.create({
  baseURL,
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export { api };
